/* eslint-disable no-else-return */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, {
    useEffect, useCallback, useContext, useState
} from 'react';
import PropTypes from 'prop-types';
import { useValidation } from 'gw-portals-validation-react';
import _ from 'lodash';
import { WizardPage, WizardPageTemplate, wizardProps } from 'gw-portals-wizard-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withRouter, useHistory } from 'react-router-dom';
import { GoogleAddressLookupComponent, initializeAddressSearchViewModel } from 'gw-ext-google-tools';
import { buildGoogleAddressRequest, getSasriaStateCode } from 'gw-capability-fnol-common-react/utils/SasriaAddressParserUtil';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import {
    lossEstimateAmountValidation,
    isLossEstimateReqdMandatory,
    mandatoryFieldSearchAddress,
    sumInsuredValidation,
    coverTypeValidation,
    indemnityPeriodValidation,
    relatedClaimValidation,
    materialDamageValidation,
    checkIfSAIdValid,
    validateLossEstimateInclAndExclValues,
    companyRegValidationCheck,
    lossEstimateAmountIncludingVATValidation
} from 'sasria-capability-fnol-common-react/Validations/ValidationUtil';
import { ModalNextProvider } from '@jutro/components';
import { messages as commonMessages } from 'gw-platform-translations';
import { validateRegNoCheckSum, validateIdNo } from 'sasria-capability-fnol-common-react/Validations/CheckSumValidation';
import Claim from '../../../gw-capability-fnol-common-react/models/Claim';
import Address from '../../../gw-capability-fnol-common-react/models/Address';
import BusinessInterruption from '../../../gw-capability-fnol-common-react/models/BusinessInterruption';
import messages from './SasriaBusinessInterruption.messages';
import metadata from './SasriaBusinessInterruption.metadata.json5';
import styles from './SasriaBusinessInterruption.module.scss';
import {
    documentsStep,
    bankDetailsStep,
    summaryStep
} from '../../../sasria-capability-fnol-common-react/ExpressClaim/ExpressClaimSteps';

function SasriaBusinessInterruption(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        },
        changeNextSteps,
        authHeader
    } = props;

    const { onValidate, isComponentValid, registerComponentValidation } = useValidation(
        'SasriaBusinessInterruption'
    );

    const history = useHistory();
    const viewModelService = useContext(ViewModelServiceContext);
    const [materialDamage, setMaterialDamage] = useState('');
    const [coverTypeIndex, setCoverTypeIndex] = useState('');
    const [showLossEstimates, setShowLossEstimates] = useState('');
    const [indArray, setArray] = useState([]);
    const [showLossEstimatesGlobal, setShowLossEstimatesglobal] = useState('');
    const [sasriaPropertyAddressData, setSasriaPropertyAddressData] = useState([]);
    const [sasriaAddressCodeValue, setSasriaAddressCodeValue] = useState('');
    const [addNew, setAddNew] = useState(false);
    const { FNOLService } = useDependencies('FNOLService');
    const [isLoading, setIsLoading] = useState(false);
    const { refreshData } = useDataRefresh();
    const [addIncidentCard, setAddIncidentCard] = useState(false);
    const [businessIncidentArray, setBusinessIncidentArray] = useState([]);
    const [totalLossEstimate, setTotalLossEstimate] = useState(Number(0));
    const [isInsuredTypeCompany, setInsuredTypeCompany] = useState(true);
    const [expressClaimSelected, setExpressClaimSelected] = useState(false);
    const [isFinalLossEstimate, setFinalLossEstimate] = useState('');
    const [insuredIDVisible, setInsuredIDVisible] = useState(true);
    const [checkFinalLossVal, setCheckFinalLossVal] = useState(false);
    const [isEditButtonClicked, setIsEditButtonClicked] = useState(false);
    const [regNumber, setRegNumber] = useState('');
    const [idNumber, setIdNumber] = useState('');
    const [passportNumber, setPassportNumber] = useState('');
    const [idType, setIdType] = useState('');
    const [claimExtension, setClaimExtension] = useState('');
    const [totalLoss, setTotalLoss] = useState('');
    const [premiumCollection, setPremiumCollection] = useState('');

    const businessInterruptionViewModel = viewModelService.create(
        _.get(claimVM.value, 'businessInterruption_EXT') || new BusinessInterruption(),
        'cc',
        'edge.capabilities.claim.fnol.dto.BusinessInterruptionDTO_EXT',
    );
    const [bIVM] = useState(businessInterruptionViewModel);

    const addressViewModel = viewModelService.create(
        _.get(bIVM.value, 'address') || new Address(),
        'cc',
        'edge.capabilities.address.dto.IncidentAddressDTO_EXT'
    );
    const [addressVM] = useState(addressViewModel);

    const expressClaimsStepsHandling = useCallback(() => {
        const nextSteps = [
            bankDetailsStep, documentsStep, summaryStep
        ];
        changeNextSteps(nextSteps);
        return claimVM;
    }, [changeNextSteps, claimVM]);

    const getAddressfilter = useCallback((addressCode) => {
        return addressCode.map((key) => {
            return {
                code: key,
                name: key
            };
        });
    }, []);

    const checkFinalLossEstimateValidation = useCallback(() => {
        const biList = claimVM.businessInterruptionIncidents_EXT.value;
        let totalIncidentAmt = null;
        let lossEstimateProvided = true;
        if (!_.isUndefined(biList) && !_.isEmpty(biList)) {
            biList.forEach((incident) => {
                const { lossEstimateInclVATValue: lossEstimateValue, haveLossEstimate } = incident;
                if (haveLossEstimate === true) {
                    if (_.isNil(totalIncidentAmt) || _.isNaN(totalIncidentAmt)) {
                        totalIncidentAmt = Number(0);
                    }
                    totalIncidentAmt += Number(lossEstimateValue);
                    setTotalLossEstimate(totalIncidentAmt);
                } else { lossEstimateProvided = false; }
            });
        }
        setShowLossEstimatesglobal(lossEstimateProvided);
        setTotalLossEstimate(totalIncidentAmt);
        _.set(claimVM.value, 'totalLossEstimate_Ext', totalIncidentAmt);
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const lossEstimateLimit = _.get(policy, 'agentLossEstimateLimit_Ext');
        const val = (lossEstimateProvided && (!_.isNil(totalIncidentAmt) && !_.isNaN(totalIncidentAmt)) && (!_.isNaN(lossEstimateLimit)) && (Number(totalIncidentAmt) <= Number(lossEstimateLimit)));
        setCheckFinalLossVal(val);
        if (!val) {
            setExpressClaimSelected(val);
        }
        return val;
    }, [claimVM.businessInterruptionIncidents_EXT.value, claimVM.value]);


    const getIdentityRegNumber = useCallback((insuredType) => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (insured) {
            if (insuredType === 'Person') {
                if (idType === 'saId') {
                    setInsuredIDVisible(true);
                    return insured.id;
                } else {
                    setInsuredIDVisible(false);
                    return insured.passportNumber;
                }
            } else if (insuredType === 'Company') {
                return insured.regNo;
            }
        }
        return undefined;
    }, [claimVM.value, idType]);

    const getIdType = useCallback((value) => {
        setIdType(value);
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (value === 'saId') {
            setIdNumber(insured.id);
            _.set(claimVM, 'insuredIdentityNumber', insured.id);
        }
        if (value === 'passport') {
            setInsuredIDVisible(false);
            setPassportNumber(insured.passportNumber);
            _.set(claimVM, 'insuredPassportNumber', insured.passportNumber);
        }
    }, [claimVM, setIdType]);

    const getDefaultIdType = useCallback(() => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (insured.id && insured.passportNumber) {
            setIdType('saId');
            setIdNumber(insured.id);
        } else if (insured.id) {
            setIdType('saId');
            setIdNumber(insured.id);
        } else if (insured.passportNumber) {
            setIdType('passport');
            setPassportNumber(insured.passportNumber);
        } else { setIdType('saId'); setIdNumber(insured.id); }
    }, [claimVM, setIdType]);

    const normalClaimsStepsHandling = useCallback(() => {
        const nextSteps = [
            documentsStep, summaryStep
        ];
        changeNextSteps(nextSteps);
        return claimVM;
    }, [changeNextSteps, claimVM]);

    const getMaterialDamage = useCallback((value) => {
        const materialDamageValue = value === 'Yes';
        _.set(bIVM.value, 'haveMaterialDamage', materialDamageValue);
        _.set(bIVM.value, 'relatedClaim', undefined);
        _.set(claimVM, 'relatedClaim', undefined);
        setMaterialDamage(value);
    }, [claimVM, bIVM]);

    const getLossEstimates = useCallback((value) => {
        const lossEstimatePresent = value === 'Yes';
        _.set(bIVM.value, 'haveLossEstimate', lossEstimatePresent);
        _.set(claimVM, 'lossEstimateInclVATValue', null);
        bIVM.lossEstimateInclVATValue = null;
        setShowLossEstimates(value);
    }, [claimVM, bIVM]);

    const handleFinalLossEstimate = useCallback((value) => {
        setFinalLossEstimate(value);
        _.set(claimVM, 'isFinalLossEstimate_EXT.value', (value === 'Yes'));
        checkFinalLossEstimateValidation();
    }, [checkFinalLossEstimateValidation, claimVM]);

    const handleCoverTypeIndexChange = useCallback((index) => {
        _.set(bIVM.value, 'coverType', index);
        setCoverTypeIndex(index);
    }, [bIVM]);

    const handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    const handleCompanyRegNumber = useCallback(() => {
        if (regNumber === '') {
            const regNo = getIdentityRegNumber('Company');
            if (!_.isNil(regNo) && !_.isUndefined(regNo)) {
                setRegNumber(regNo);
                _.set(claimVM, 'companyRegistrationNumber', regNo);
                _.set(claimVM.value, 'companyRegistrationNumber', regNo);
            } else {
                _.set(claimVM, 'companyRegistrationNumber', regNumber);
                _.set(claimVM.value, 'companyRegistrationNumber', regNumber);
            }
        }
    }, [claimVM, getIdentityRegNumber, regNumber]);

    const handleIdNumber = useCallback(() => {
        if (idType === 'saId') {
            if (idNumber === '') {
                const idNo = getIdentityRegNumber('Person');
                if (!_.isNil(idNo) && !_.isUndefined(idNo)) {
                    setIdNumber(idNo);
                    _.set(claimVM, 'insuredIdentityNumber', idNo);
                    _.set(claimVM.value, 'insuredIdentityNumber', idNo);
                }
            } else {
                _.set(claimVM, 'insuredIdentityNumber', idNumber);
                _.set(claimVM.value, 'insuredIdentityNumber', idNumber);
            }
        } else if (passportNumber === '') {
            const passport = getIdentityRegNumber('Person');
            if (!_.isNil(passport) && !_.isUndefined(passport)) {
                setPassportNumber(passport);
                _.set(claimVM, 'insuredPassportNumber', passport);
                _.set(claimVM.value, 'insuredPassportNumber', passport);
            }
        } else {
            _.set(claimVM, 'insuredPassportNumber', passportNumber);
            _.set(claimVM.value, 'insuredPassportNumber', passportNumber);
        }
    }, [claimVM, getIdentityRegNumber, idNumber, idType, passportNumber]);

    const handleCompanyOrInsured = useCallback(() => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (insured) {
            const { insuredType } = insured;
            if (insuredType === 'InsuredCompany_EXT') {
                setInsuredTypeCompany(true);
                handleCompanyRegNumber();
            } else {
                setInsuredTypeCompany(false);
                handleIdNumber();
            }
        }
    }, [claimVM.value, handleCompanyRegNumber, handleIdNumber]);


    const validateInsuredIdentity = useCallback(() => {
        if (!expressClaimSelected) {
            return true;
        }
        let insuredIdNumber = _.get(claimVM.value, 'insuredIdentityNumber');
        let insuredPassportNumber = _.get(claimVM.value, 'insuredPassportNumber');
        const companyRegNumber = _.get(claimVM.value, 'companyRegistrationNumber');
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (insured) {
            const { insuredType } = insured;
            if (insuredType === 'InsuredCompany_EXT') {
                setInsuredTypeCompany(true);
                if (!companyRegValidationCheck(companyRegNumber)) { return false; }
                if (!validateRegNoCheckSum(companyRegNumber)) {
                    return false;
                }
            } else {
                setInsuredTypeCompany(false);
                if (idType === 'saId') {
                    if (_.isUndefined(insuredIdNumber)) {
                        insuredIdNumber = _.get(insured, 'id');
                    }
                    const id = new RegExp(/^([0-9]{13})$/);
                    if (_.isEmpty(insuredIdNumber) || insuredIdNumber === undefined || !id.test(insuredIdNumber)) {
                        handleError(messages.idNoValidationTitle, messages.idNoValidationMessage);
                        return false;
                    }
                    if (!validateIdNo(insuredIdNumber)) {
                        return false;
                    }
                } else {
                    if (_.isUndefined(insuredPassportNumber)) {
                        insuredPassportNumber = _.get(insured, 'passportNumber');
                    }
                    const validPassport = new RegExp(/^([a-zA-Z0-9]{1,13})$/);
                    if (insuredPassportNumber === undefined || !validPassport.test(insuredPassportNumber) || insuredPassportNumber.length > 13) {
                        // eslint-disable-next-line no-use-before-define
                        handleError(
                            messages.passportNoValidationTitle,
                            messages.passportNoValidationMessage
                        );
                        return false;
                    }
                }
            }
        }

        FNOLService.validateInsuredData_Ext(insured, insuredIdNumber, insuredPassportNumber, companyRegNumber, authHeader);
        return ModalNextProvider.showConfirm({
            title: 'Validation Success',
            message: 'Insured\'s identity has been validated',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, [FNOLService, authHeader, claimVM.value, expressClaimSelected, idType]);

    const setValuesOnPrevious = useCallback(() => {
        setRegNumber(_.get(claimVM, 'companyRegistrationNumber'));
        // setIdNumber(_.get(claimVM, 'insuredIdentityNumber'));
        // setPassportNumber(_.get(claimVM, 'insuredPassportNumber'));

        // R2S-509
        if ((typeof _.get(claimVM, 'insuredIdentityNumber')) === 'object') {
            setIdNumber(undefined);
        } else {
            setIdNumber(_.get(claimVM, 'insuredIdentityNumber'));
        }

        if ((typeof _.get(claimVM, 'insuredPassportNumber')) === 'object') {
            setPassportNumber(undefined);
        } else {
            setPassportNumber(_.get(claimVM, 'insuredPassportNumber'));
        }
        if (!_.isNil(_.get(bIVM.value, 'coverType'))) {
            const coverType = _.get(bIVM.value, 'coverType');
            setCoverTypeIndex(coverType);
        }

        if (!_.isNil(_.get(claimVM, 'isFinalLossEstimate_EXT.value'))) {
            const finalLossEstimate = _.get(claimVM, 'isFinalLossEstimate_EXT.value');
            if (finalLossEstimate === true) {
                setFinalLossEstimate('Yes');
            } else {
                setFinalLossEstimate('No');
            }
        }
        const expressClaimDetails = _.get(claimVM.value, 'sasriaExpressClaimDetails_EXT');
        if (!_.isUndefined(expressClaimDetails) && !_.isUndefined(expressClaimDetails.isExpressClaimSelected)) { setExpressClaimSelected(expressClaimDetails.isExpressClaimSelected); }
        if (!_.isUndefined(expressClaimDetails)) {
            setFinalLossEstimate(expressClaimDetails.isThisFinalLossEstimate ? 'Yes' : 'No');
        }
        handleCompanyOrInsured();
        const val = checkFinalLossEstimateValidation();
        if (!val) {
            setExpressClaimSelected(val);
        }
    }, [bIVM.value, checkFinalLossEstimateValidation, claimVM, handleCompanyOrInsured]);

    const handleExtensionValue = useCallback((value) => {
        const extensionPresent = value === 'Yes';
        _.set(bIVM.value, 'claimExtension', extensionPresent);
        // _.set(claimVM, 'propertyIncident_EXT', null);
        setClaimExtension(value);
        if (extensionPresent === true) {
            setExpressClaimSelected(false);
        }
    }, [bIVM.value]);

    const handlePremiumCollection = useCallback((value) => {
        const isPremiumCollection = value === 'Yes';
        _.set(bIVM.value, 'bankPremium', isPremiumCollection);
        // _.set(claimVM, 'propertyIncident_EXT', null);
        setPremiumCollection(value);
        if (isPremiumCollection === false) {
            setExpressClaimSelected(false);
        }
        _.set(bIVM.value, 'expressClaim', null);
    }, [bIVM.value]);

    const handleLossValue = useCallback((value) => {
        const totalLossPresent = value === 'Yes';
        _.set(bIVM.value, 'totalLoss', totalLossPresent);
        // _.set(claimVM, 'propertyIncident_EXT', null);
        setTotalLoss(value);
        if (totalLossPresent === true) {
            setExpressClaimSelected(false);
        }
    }, [bIVM.value]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(bIVM, path, value);
            if (path === 'lossEstimateValue') {
                const lossEstimateValue = _.get(bIVM, 'lossEstimateValue');
                if (lossEstimateValue.value === '1b') {
                    _.set(bIVM, 'lossEstimateValue', 1000000000);
                } else if (lossEstimateValue.value === '1m') {
                    _.set(bIVM, 'lossEstimateValue', 1000000);
                } else if (lossEstimateValue.value === '1t') {
                    _.set(bIVM, 'lossEstimateValue', 1000000000000);
                }
                _.set(claimVM, 'lossEstimateValue', bIVM.lossEstimateValue.value);
            }

            if (path === 'companyRegistrationNumber') {
                setRegNumber(value);
                _.set(claimVM, 'companyRegistrationNumber', value);
                _.set(claimVM.value, 'companyRegistrationNumber', value);
            }
            if (path === 'insuredIdentityNumber') {
                setIdNumber(value);
                _.set(claimVM, 'insuredIdentityNumber', value);
                _.set(claimVM.value, 'insuredIdentityNumber', value);
            }
            if (path === 'insuredPassportNumber') {
                setPassportNumber(value);
                _.set(claimVM, 'insuredPassportNumber', value);
                _.set(claimVM.value, 'insuredPassportNumber', value);
            }
            // _.set(addressVM.value, 'address', value);
            _.set(bIVM.value, 'address', addressVM.value);
            _.set(claimVM.value, 'businessInterruption_EXT', bIVM.value);
        },
        [claimVM, bIVM, addressVM]
    );

    const handleExclVatAmount = useCallback((value) => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const vatPercent = _.get(policy, 'vatPercent_EXT', 0);
        const upper = Number(value) * Number(100);
        const exclValue = upper / (Number(vatPercent) + Number(100));
        _.set(bIVM.value, 'lossEstimateValue', exclValue.toFixed(2));
    }, [claimVM, bIVM]);

    const retrievePropertyIncident = useCallback(() => {
        const lossLocation = _.get(claimVM.value, 'lossLocation');
        const addressList = [];
        if (lossLocation) {
            // eslint-disable-next-line max-len
            addressList.push(buildGoogleAddressRequest(lossLocation));
        }
        // eslint-disable-next-line no-use-before-define
        const sasriaPropertyAddressArray = getAddressfilter(addressList);
        setSasriaPropertyAddressData(sasriaPropertyAddressArray);
    // eslint-disable-next-line no-use-before-define
    }, [claimVM.value, getAddressfilter]);

    const addNewIncident = useCallback(() => {
        retrievePropertyIncident();
        setShowLossEstimates('');
        _.set(claimVM, 'haveLossEstimate', undefined);
        _.set(claimVM, 'lossEstimateValue', undefined);
        _.set(claimVM, 'lossEstimateInclVATValue', undefined);
        _.set(claimVM, 'sumInsured', undefined);
        setCoverTypeIndex('');
        _.set(claimVM, 'coverType', undefined);
        _.set(claimVM, 'indemnityPeriod', undefined);
        _.set(claimVM, 'relatedClaim', undefined);
        setMaterialDamage('');
        _.set(claimVM, 'haveMaterialDamage', '');
        _.set(claimVM, 'address', new Address());
        bIVM.haveLossEstimate = null;
        bIVM.lossEstimateValue = null;
        bIVM.lossEstimateInclVATValue = null;
        bIVM.sumInsured = null;
        bIVM.coverType = null;
        bIVM.indemnityPeriod = null;
        bIVM.relatedClaim = null;
        bIVM.haveMaterialDamage = null;
        bIVM.address.addressLine1 = null;
        bIVM.address.addressLine2 = null;
        bIVM.address.addressLine3 = null;
        bIVM.address.suburb = null;
        bIVM.address.province = null;
        bIVM.address.city = null;
        bIVM.address.postalCode = null;
        bIVM.address.state = null;
        bIVM.address.unitorComplexorBranch = null;
        bIVM.address.displayName = null;
        _.set(claimVM.value, 'businessInterruption_EXT', bIVM.value);
        updateWizardData(claimVM);
        setAddNew(!addNew);
        setAddIncidentCard(false);
    }, [addNew, bIVM.address.addressLine1, bIVM.address.addressLine2, bIVM.address.addressLine3, bIVM.address.city, bIVM.address.displayName, bIVM.address.postalCode, bIVM.address.province, bIVM.address.state, bIVM.address.suburb, bIVM.address.unitorComplexorBranch, bIVM.coverType, bIVM.haveLossEstimate, bIVM.haveMaterialDamage, bIVM.indemnityPeriod, bIVM.lossEstimateInclVATValue, bIVM.lossEstimateValue, bIVM.relatedClaim, bIVM.sumInsured, bIVM.value, claimVM, retrievePropertyIncident, updateWizardData]);

    const addIncidentCardFunc = useCallback(
        () => {
            const haveLossEstimate = _.get(bIVM.value, 'haveLossEstimate');
            const lossEstimateInclVATValue = _.get(bIVM.value, 'lossEstimateInclVATValue');
            if (haveLossEstimate === true) {
                handleExclVatAmount(lossEstimateInclVATValue);
            }
            const lossEstimateValue = _.get(bIVM.value, 'lossEstimateValue');
            setIsLoading(true);
            const incidentList = _.get(claimVM, 'businessInterruptionIncidents_EXT.value');
            if (businessIncidentArray.length === 0 && !_.isUndefined(incidentList) && incidentList.length >= 1) {
                businessIncidentArray.push(...incidentList);
            }
            const sumInsured = _.get(bIVM.value, 'sumInsured');
            const coverType = _.get(bIVM.value, 'coverType');
            const indemnityPeriod = _.get(bIVM.value, 'indemnityPeriod');
            const relatedClaim = _.get(bIVM.value, 'relatedClaim');
            const haveMaterialDamage = _.get(bIVM.value, 'haveMaterialDamage');
            // eslint-disable-next-line no-shadow
            const {
                addressLine1, addressLine2, addressLine3, suburb, province, city, state, postalCode, unitorComplexorBranch, displayName, country
            } = bIVM.address.value;
            const address = {
                addressLine1, addressLine2, addressLine3, suburb, province, city, state, postalCode, unitorComplexorBranch, displayName, country
            };

            if (!isLossEstimateReqdMandatory(haveLossEstimate)) return false;
            // if (!lossEstimateAmountValidation(haveLossEstimate, lossEstimateValue)) return false;
            if (!lossEstimateAmountIncludingVATValidation(haveLossEstimate, lossEstimateInclVATValue)) return false;

            // if (!validateLossEstimateInclAndExclValues(haveLossEstimate, lossEstimateValue, lossEstimateInclVATValue)) {
            //     return false;
            // }
            // if (!sumInsuredValidation(sumInsured)) return false;
            // if (!coverTypeValidation(coverType)) return false;
            // if (!indemnityPeriodValidation(indemnityPeriod)) return false;
            // if (!materialDamageValidation(haveMaterialDamage)) return false;
            if (haveMaterialDamage) {
                if (!relatedClaimValidation(relatedClaim)) return false;
            }
            const businessInterruptIncident = {
                // eslint-disable-next-line object-property-newline
                address, haveLossEstimate, lossEstimateValue, sumInsured, coverType, indemnityPeriod, relatedClaim, haveMaterialDamage, lossEstimateInclVATValue
            };
            businessIncidentArray.push(businessInterruptIncident);
            setBusinessIncidentArray(businessIncidentArray);
            _.set(claimVM.value, 'businessInterruptionIncidents_EXT', businessIncidentArray);
            if (isEditButtonClicked === true) {
                setIsEditButtonClicked(false);
            }
            setAddIncidentCard(true);
            setAddNew(false);
            updateWizardData(claimVM);
            checkFinalLossEstimateValidation();
        },
        [bIVM.value, bIVM.address.value, claimVM, businessIncidentArray, isEditButtonClicked, updateWizardData, checkFinalLossEstimateValidation, handleExclVatAmount]
    );

    const handlePropertyChange = useCallback(
        (addressIndex) => {
            setSasriaAddressCodeValue(addressIndex);
            const lossLocation = _.get(claimVM.value, 'lossLocation');
            if (lossLocation) {
                _.set(addressVM, 'unitorComplexorBranch.value', lossLocation.unitorComplexorBranch);
                _.set(addressVM, 'addressLine1.value', lossLocation.addressLine1);
                _.set(addressVM, 'suburb.value', lossLocation.suburb);
                _.set(addressVM, 'city.value', lossLocation.city);
                _.set(addressVM, 'state.value', lossLocation.state);
                _.set(addressVM, 'province.value', lossLocation.province);
                _.set(addressVM, 'postalCode.value', lossLocation.postalCode);
                _.set(bIVM.value, 'address', addressVM.value);
                updateWizardData(claimVM);
            }
        },
        [addressVM, claimVM, bIVM.value, updateWizardData]
    );

    const onNext = useCallback(() => {
        const incident = _.get(claimVM, 'businessInterruptionIncidents_EXT.value');

        if ((_.isUndefined(incident)) || (_.isEmpty(incident))) {
            ModalNextProvider.showAlert({
                title: 'Error',
                message: 'Please add incident/incidents before clicking on Next',
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return false;
        }
        setIsLoading(true);
        const expressClaimDataFromPrevScreen = _.get(claimVM.value, 'sasriaExpressClaimDetails_EXT');
        if (_.isNil(expressClaimDataFromPrevScreen)) {
            const expressClaimDetails = {
                isThisFinalLossEstimate: (isFinalLossEstimate === 'Yes'),
                isExpressClaimSelected: expressClaimSelected,
                totalLossEstimate: totalLossEstimate
            };
            _.set(claimVM.value, 'sasriaExpressClaimDetails_EXT', expressClaimDetails);
        } else {
            _.set(expressClaimDataFromPrevScreen, 'isThisFinalLossEstimate', (isFinalLossEstimate === 'Yes'));
            _.set(expressClaimDataFromPrevScreen, 'isExpressClaimSelected', expressClaimSelected);
            _.set(expressClaimDataFromPrevScreen, 'totalLossEstimate', totalLossEstimate);
            _.set(claimVM.value, 'sasriaExpressClaimDetails_EXT', expressClaimDataFromPrevScreen);
        }
        if (!validateInsuredIdentity()) { return false; }
        return FNOLService.getFNOLDetails_EXT(claimVM.value, authHeader)
            .then((response) => {
                claimVM.value = new Claim(response);
                _.set(claimVM.value, 'totalLossEstimate_Ext', totalLossEstimate);
                return (isFinalLossEstimate === 'Yes' && expressClaimSelected) ? expressClaimsStepsHandling() : normalClaimsStepsHandling();
            })
            .catch((err) => {
                return history.push('/claims');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [FNOLService, authHeader, claimVM, expressClaimSelected, expressClaimsStepsHandling, history, isFinalLossEstimate, normalClaimsStepsHandling, totalLossEstimate, validateInsuredIdentity]);

    const deleteIncidentCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            ModalNextProvider.showConfirm({
                title: 'Warning',
                message: 'Are you sure you want to remove this Incident?',
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(async (results) => {
                if (results === 'cancel') {
                    return _.noop();
                }
                const bIIncidentList = _.get(claimVM, 'businessInterruptionIncidents_EXT.value');
                bIIncidentList.splice((index), 1);
                _.set(claimVM, 'businessInterruptionIncidents_EXT.value', bIIncidentList);
                _.set(claimVM, 'businessInterruption_EXT', undefined);
                checkFinalLossEstimateValidation();
                updateWizardData(claimVM);
                return true;
            }, _.noop);
        },
        [claimVM, updateWizardData, checkFinalLossEstimateValidation]
    );

    const editIncidentCard = useCallback(
        // eslint-disable-next-line consistent-return
        (e, item, index) => {
            e.preventDefault();
            setIsEditButtonClicked(true);
            const bIIncidentList = _.get(claimVM, 'businessInterruptionIncidents_EXT.value');
            bIIncidentList.splice((index), 1);
            setBusinessIncidentArray(bIIncidentList);
            _.set(claimVM, 'businessInterruptionIncidents_EXT.value', businessIncidentArray);
            _.set(claimVM.value, 'businessInterruption_EXT', item);
            bIVM.value = item;
            const {
                address, haveLossEstimate, lossEstimateValue, sumInsured, coverType, indemnityPeriod, relatedClaim, haveMaterialDamage, lossEstimateInclVATValue
            } = item;

            _.set(claimVM, 'address', address);
            _.set(addressVM, 'unitorComplexorBranch.value', address.unitorComplexorBranch);
            _.set(addressVM, 'addressLine1.value', address.addressLine1);
            _.set(addressVM, 'suburb.value', address.suburb);
            _.set(addressVM, 'city.value', address.city);
            _.set(addressVM, 'state.value', address.state);
            _.set(addressVM, 'province.value', address.province);
            _.set(addressVM, 'postalCode.value', address.postalCode);
            _.set(bIVM.value, 'address', addressVM.value);

            _.set(claimVM, 'haveLossEstimate', haveLossEstimate);
            _.set(claimVM, 'lossEstimateValue', lossEstimateValue);
            _.set(claimVM, 'lossEstimateInclVATValue', lossEstimateInclVATValue);
            _.set(claimVM, 'sumInsured', sumInsured);
            _.set(claimVM, 'coverType', coverType);
            _.set(claimVM, 'indemnityPeriod', indemnityPeriod);
            _.set(claimVM, 'relatedClaim', relatedClaim);
            _.set(claimVM, 'haveMaterialDamage', haveMaterialDamage);
            setShowLossEstimates(haveLossEstimate === true ? 'Yes' : 'No');
            setCoverTypeIndex(coverType);
            setMaterialDamage(haveMaterialDamage === true ? 'Yes' : 'No');
            setAddIncidentCard(false);
            setAddNew(true);
            updateWizardData(claimVM);
        },
        [addressVM, bIVM.value, businessIncidentArray, claimVM, updateWizardData]
    );

    const generateIncidentCardOverrides = useCallback(() => {
        const incidentArray = _.get(claimVM.value, 'businessInterruptionIncidents_EXT', []);
        const overrides = incidentArray.map((elem, index) => {
            return {
                // [`individualCoverType${index}`]: {
                //     value: `${elem.coverType}`
                // },

                [`individualAmount${index}`]: {
                    value: `R${elem.sumInsured}`
                },
                [`individualIndemnityPeriod${index}`]: {
                    value: `${elem.indemnityPeriod} Months`
                },
                [`deleteIncident${index}`]: {
                    onClick: (e) => {
                        deleteIncidentCard(e, elem, index);
                    }
                },

                [`editIncident${index}`]: {
                    onClick: (e) => {
                        editIncidentCard(e, elem, index);
                    }
                },
            };
        });
        return Object.assign({}, ...overrides);
    }, [claimVM, deleteIncidentCard, editIncidentCard]);

    const getAddressVisibility = useCallback((fieldPath) => {
        if (bIVM.value) {
            const address = _.get(bIVM.value, 'address');
            if (address) {
                const field = _.get(address, fieldPath);
                return !_.isEmpty(field) && !_.isNil(field);
            }
        }
        return false;
    }, [bIVM]);

    const validateAddIncident = useCallback(() => {
        const incidentArray = _.get(claimVM, 'businessInterruptionIncidents_EXT.value', []);
        return (incidentArray.length !== 0 && isEditButtonClicked === false && addNew === false);
    }, [addNew, claimVM, isEditButtonClicked]);

    useEffect(() => { registerComponentValidation(validateAddIncident); }, [
        registerComponentValidation, validateAddIncident]);


    useEffect(() => {
        setValuesOnPrevious();
        handleCompanyOrInsured();
        getDefaultIdType();
        _.set(bIVM.value, 'address', addressViewModel.value);
        _.set(claimVM.value, 'businessInterruption_EXT', bIVM.value);
        updateWizardData(claimVM);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onExpressClaimSwitch = useCallback((value, path) => {
        handleCompanyRegNumber();
        handleIdNumber();
        setExpressClaimSelected(value);
    }, [handleCompanyRegNumber, handleIdNumber]);


    const overrideProps = {
        haveLossEstimate: {
            value: showLossEstimates
        },
        lossEstimateValue: {
            visible: false
        },
        materialDamageId: {
            value: materialDamage
        },
        relatedClaim: {
            visible: materialDamage === 'Yes'
        },
        addressLookup: {
            model: bIVM,
            path: initializeAddressSearchViewModel(bIVM, 'address'),
            label: {
                id: 'fnol.common.views.fnol.Search Address',
                defaultMessage: 'Search Address'
            },
            claimModel: claimVM,
            claimModelPresent: true,
            modelPath: 'businessInterruption_EXT'
        },
        sasriaAddressList: {
            availableValues: sasriaPropertyAddressData,
            value: sasriaAddressCodeValue,
            visible: true
        },
        coverTypeList: {
            value: coverTypeIndex
        },
        sasriaAddress: {
            visible: getAddressVisibility('addressLine1')
        },
        sasriaSuburb: {
            visible: getAddressVisibility('suburb')
        },
        sasriaCity: {
            visible: getAddressVisibility('city')
        },
        sasriaState: {
            visible: getAddressVisibility('state')
        },
        sasriaZipCode: {
            visible: getAddressVisibility('postalCode')
        },
        totalComponent: {
            visible: (addNew === true && addIncidentCard === false),
            claimModelPresent: true,
        },
        mapContainer: {
            visible: (addNew === true && addIncidentCard === false),
            claimModelPresent: true
        },
        companyRegistrationNumber: {
            visible: isInsuredTypeCompany && expressClaimSelected && checkFinalLossVal && isFinalLossEstimate === 'Yes',
            value: regNumber
        },
        isThisFinalLossEstimate: {
            visible: !_.get(claimVM.value, 'sasriaDuplicateClaimExists_EXT', false),
            value: isFinalLossEstimate
        },
        expressClaim: {
            visible: !_.get(claimVM.value, 'sasriaDuplicateClaimExists_EXT', false) && isFinalLossEstimate === 'Yes' && checkFinalLossVal && claimExtension === 'No' && totalLoss === 'No' && premiumCollection === 'Yes',
            value: expressClaimSelected
        },
        insuredIdentityInvalid: {
            visible: expressClaimSelected && idType === 'saId' && !isInsuredTypeCompany && checkFinalLossVal && isFinalLossEstimate === 'Yes',
            value: idNumber
        },
        insuredPassportInvalid: {
            visible: expressClaimSelected && idType === 'passport' && isFinalLossEstimate === 'Yes',
            value: passportNumber
        },
        lossEstimateincludingVat: {
            visible: showLossEstimates === 'Yes'
        },
        selectIdRadioButton: {
            visible: expressClaimSelected && !isInsuredTypeCompany && checkFinalLossVal && isFinalLossEstimate === 'Yes',
            value: idType
        },
        checkValidation: {
            visible: expressClaimSelected && checkFinalLossVal && isFinalLossEstimate === 'Yes'
        },
        totalLoss: {
            value: totalLoss
        },
        claimExtension: {
            value: claimExtension
        },
        bankPremium: {
            value: premiumCollection
        },
        ...generateIncidentCardOverrides(),
    };

    const resolvers = {
        resolveCallbackMap: {
            handleLossEstimates: getLossEstimates,
            handleMaterialDamage: getMaterialDamage,
            handleCoverTypeIndexChange: handleCoverTypeIndexChange,
            addNewIncident: addNewIncident,
            addIncidentCardFunc: addIncidentCardFunc,
            onExpressClaimSwitch: onExpressClaimSwitch,
            handleFinalLossEstimate: handleFinalLossEstimate,
            validateInsuredIdentity: validateInsuredIdentity,
            handlePropertyChange: handlePropertyChange,
            getIdType: getIdType,
            handleExtensionValue: handleExtensionValue,
            handleLossValue: handleLossValue,
            handlePremiumCollection: handlePremiumCollection
        },
        resolveComponentMap: {
            addresslookupcomponent: GoogleAddressLookupComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, path) => {
            return readViewModelValue(
                metadata.pageContent,
                claimVM,
                fieldId,
                path,
                overrideProps
            );
        },
        [claimVM, overrideProps]
    );

    return (
        <WizardPage
            onNext={onNext}
            disableNext={!isComponentValid}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                resolveValue={readValue}
                onValueChange={writeValue}
            />
        </WizardPage>
    );
}

SasriaBusinessInterruption.propTypes = wizardProps;
SasriaBusinessInterruption.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};
export default withRouter(withAuthenticationContext(SasriaBusinessInterruption));
